import React from 'react'
import PropTypes from 'prop-types'
import {Box, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useProduct} from '@salesforce/commerce-sdk-react'
import ProductCarousel from '../../../../app/components/product-carousel'
import {pdProductCarousalStyles} from '../../../theme/components/project/pdpage-product-recommendation-styles'
/**
 * Einstein Carousel Product
 * @param {object} props
 * @returns {React.ReactElement} - EinsteinCarouselProduct component.
 */
export const EinsteinCarouselProduct = ({textHeadline, recommender, count, product}) => {
    const {data: recommendationProduct, isLoading: recommendationProductIsLoading} = useProduct({
        parameters: {
            id: product,
            allImages: false
        }
    })

    return (
        <Box sx={pdProductCarousalStyles} className="carousel-wrapper">
            <Box
                data-test-id="category-product-tile-carousal"
                position="relative"
                pb={6}
                className="pd-product-carousal-container"
            >
                <Heading className="recommenderHeading" as={'h2'}>
                    {textHeadline ?? ''}
                </Heading>

                {/* Einstein Carousel */}
                {recommender && recommender.value && !recommendationProductIsLoading && (
                    <Box className={'einsteinRecommendations'}>
                        <ProductCarousel
                            recommender={recommender.value}
                            count={count}
                            recommendationProduct={recommendationProduct}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    )
}

EinsteinCarouselProduct.propTypes = {
    textHeadline: PropTypes.string,
    displayRatings: PropTypes.bool,
    recommender: PropTypes.shape({
        value: PropTypes.string
    }),
    count: PropTypes.string,
    product: PropTypes.string
}

export default EinsteinCarouselProduct
